<dialog-gala (clickClose)="hide()">
    <span gala-dialog-titre>{{lgTrad.NEWPROFIL}}</span>
    <form [formGroup]="formProfilAjout" autocomplete="off">
        <div class="form-row">
            <div class="col-md-12">
                <input-gala formControlName="PROFIL" placeholder="{{lgTrad.NOMPROFIL}}"
                    icone="fas fa-male " />
            </div>
        </div>
        <select-gala formControlName="IDAPPLICATIF" [options]="listeApplicatif" bindLabel="NOMAPP"
            bindValue="IDAPPLICATIF" placeholder="{{lgTrad.PHAPP}}" icone="fas fa-laptop" />
    </form>
    <div gala-dialog-actions>
        <button mat-stroked-button color="primary" (click)="onCreerProfil()">{{lgTrad.VAL}}</button>
    </div>
</dialog-gala>
